function getEventCoordinates(event) {
  if (event.touches) {
    const [touch] = event.changedTouches;

    return {
      pageX: touch.pageX,
      pageY: touch.pageY,
    };
  }

  return {
    pageX: event.pageX,
    pageY: event.pageY,
  };
}

function findMinMaxCoordinates(event: TouchEvent) {
  const coordinates: {
    minX?: number;
    maxX?: number;
    minY?: number;
    maxY?: number;
  } = {};

  [].forEach.call(event.touches, (e) => {
    const x = e.pageX;
    const y = e.pageY;

    if (!coordinates.minX || x < coordinates.minX) coordinates.minX = x;
    if (!coordinates.maxX || x > coordinates.maxX) coordinates.maxX = x;
    if (!coordinates.minY || y < coordinates.minY) coordinates.minY = y;
    if (!coordinates.maxY || y > coordinates.maxY) coordinates.maxY = y;
  });

  return coordinates;
}

export { getEventCoordinates, findMinMaxCoordinates };
